import axios from '../../core/http';

import { config } from '../../config';
import { getAuthorizationHeader } from '../authHeaders';

const baseInvoiceControlApiUrl = `${config.baseInpulseInvoiceControlApiUrl}`;

const getStandardHeaders = async () => {
  const accessToken = await getAuthorizationHeader();

  return {
    'Content-Type': 'application/json',
    Authorization: accessToken,
  };
};

/**
 * This file aims to centralize all axios-related logic, reducing the amount of code
 * necessary to perform an API call.
 *
 * @param {string} url - The relative or absolute URL to request data from.
 * @param {Object} params - Optional query parameters to be sent with the request.
 * @param {string} responseType - The type of data to return. Default: 'json'
 * @return {Promise<any>} A Promise that resolves with the response data from the server.
 *
 */
const apiGet =
  (baseInvoiceControlApiUrl) =>
  async (url, params, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.get(`${baseInvoiceControlApiUrl}${url}`, {
      params,
      headers,
      ...config,
    });

    return data;
  };

const apiPost =
  (baseInvoiceControlApiUrl) =>
  async (url, bodyParams, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.post(
      `${baseInvoiceControlApiUrl}${url}`,
      { ...bodyParams },
      { headers, ...config },
    );

    return data;
  };

const apiPut =
  (baseInvoiceControlApiUrl) =>
  async (url, bodyParams, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.put(
      `${baseInvoiceControlApiUrl}${url}`,
      { ...bodyParams },
      { headers, ...config },
    );

    return data;
  };

const apiPatch =
  (baseInvoiceControlApiUrl) =>
  async (url, bodyParams, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.patch(
      `${baseInvoiceControlApiUrl}${url}`,
      { ...bodyParams },
      { headers, ...config },
    );

    return data;
  };

const apiDelete =
  (baseInvoiceControlApiUrl) =>
  async (url, payload, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.delete(`${baseInvoiceControlApiUrl}${url}`, {
      headers,
      data: payload,
      ...config,
    });

    return data;
  };

export const InvoiceControlAPIcaller = {
  apiGet: apiGet(baseInvoiceControlApiUrl),
  apiPost: apiPost(baseInvoiceControlApiUrl),
  apiPut: apiPut(baseInvoiceControlApiUrl),
  apiPatch: apiPatch(baseInvoiceControlApiUrl),
  apiDelete: apiDelete(baseInvoiceControlApiUrl),
};
